import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16 4a1 1 0 0 1 1 1v2.753l7.778-1.728.038-.008a1 1 0 0 1 1.118.626l3.994 9.986Q30 16.808 30 17c0 1.561-.91 2.597-1.934 3.194-.994.579-2.175.806-3.066.806-.89 0-2.072-.227-3.066-.806C20.91 19.597 20 18.56 20 17q0-.192.072-.371l3.296-8.242L17 9.802V26h2a1 1 0 1 1 0 2h-6a1 1 0 1 1 0-2h2V10.247L8.365 11.72l3.563 8.908Q12 20.808 12 21c0 1.561-.91 2.597-1.934 3.194C9.072 24.773 7.891 25 7 25c-.89 0-2.072-.227-3.066-.806C2.91 23.597 2 22.56 2 21a1 1 0 0 1 .072-.371l3.993-9.984a1 1 0 0 1 .723-.622L15 8.198V5a1 1 0 0 1 1-1M4.008 21.172c.055.562.386.975.933 1.294.631.367 1.45.534 2.059.534s1.428-.166 2.059-.534c.547-.32.878-.732.933-1.294L7 13.692zm18.933-2.706c-.547-.32-.877-.732-.933-1.294L25 9.692l2.992 7.48c-.056.562-.386.975-.933 1.294-.631.367-1.45.534-2.059.534s-1.428-.166-2.059-.534"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconBudget = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconBudget);
export default Memo;
